import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class FooterAPI extends ComponentAPI {
    /**
     * Returns the text shown by the component.
     */
    getTextExpression() {
        return this.state.textExpression;
    }
    /**
     * Updates the text shown by the component.
     *
     * @param textExpression - The new text shown by the component.
     */
    setTextExpression(textExpression) {
        this.setState({ textExpression });
    }
    /**
     * Returns the visibility state of the component.
     */
    isVisible() {
        return this.state.visible;
    }
    /**
     * Updates the visibility state of the component.
     *
     * @param visible - The new visibility state to set for the component.
     */
    setVisible(visible) {
        this.setState({ visible });
    }
}
export { FooterAPI, };
//# sourceMappingURL=footer-api.js.map